import { Box, Typography, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
const Gift = ({ from, to, message }) => {
  const { survey_token } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState("");
  useEffect(() => {
    getServicesList(survey_token);
  }, [survey_token]);

  const getServicesList = async (survey_token) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        "https://api.nopapertimesheet.com/api/lead/get-details",
        {
          params: { uuid: survey_token },
        }
      );
      
      if (response?.data?.r?.lead_status === null || response?.data?.r?.lead_status === 0) {
        navigate("/");
        return;
      }
      if (response && response?.data?.s === 0) {
        navigate("/");
      }
      setData(response?.data?.r);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundImage: `url("/giftbg.jpg")`,
        backgroundSize: "400px",
        backgroundPosition: "center",
        backgroundRepeat: "repeat",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: { xs: "90%", sm: "450px" },
          padding: 5,
          borderRadius: 2,
          textAlign: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          position: "relative",
        }}
      >
        {" "}
        <Box
          sx={{
            position: "absolute",
            width: { xs: "80px", md: "120px" },
            left: 0,
            top: 0,
          }}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src="/ribbon.png"
            alt="ribbon"
          />
        </Box>
        <Typography
          sx={{ fontFamily: "Dancing Script" }}
          variant="h3"
          color="primary"
          gutterBottom
        >
          Gift Card
        </Typography>
        <Typography sx={{ fontFamily: "Poppins" }} variant="body1">
          <strong style={{ fontFamily: "Poppins" }}>From: </strong> {from}
          {data?.company_details?.company_name}
        </Typography>
        <Typography sx={{ fontFamily: "Poppins" }} variant="body1">
          <strong style={{ fontFamily: "Poppins" }}>To: </strong> {to}
          {data?.name}
        </Typography>
        <Typography sx={{ fontFamily: "Poppins" }} variant="body1">
          <strong style={{ fontFamily: "Poppins" }}>Reward:</strong> {to}
          {data?.company_details?.lead_config?.gifting_text}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontStyle: "Poppins", mt: 1, color: "#555" }}
        >
          {message}
        </Typography>
      </Paper>
    </Box>
  );
};

export default Gift;
